module.exports = __webpack_public_path__ + "img/mac-pc.e6a116ce.png";